import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getCode } from "core-integration/src/store/leagues/reducers";
import {
  fetchLeagueCode,
  regenerateLeagueCode,
} from "core-integration/src/store/leagues/thunks";
import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import { Button } from "plos/src/components/buttons/Button";
import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { codeWrapper, pText } from "./code.css";

interface Props {
  league: IPrivateLeagueAdmin;
}

const Code = ({ league }: Props) => {
  const { t } = useTranslation("leaguesAndCups");
  const dispatch = useDispatch<ThunkDispatch>();
  const code = useSelector((state: RootState) => getCode(state, league.id));

  useEffect(() => {
    if (!league.closed) {
      dispatch(fetchLeagueCode(league.id));
    }
  }, [dispatch, league.closed, league.id]);

  if (league.closed) {
    return null;
  }

  const handleRegenerateCode = (leagueId: number) =>
    dispatch(regenerateLeagueCode(leagueId));

  return (
    <div className={codeWrapper}>
      <p className={pText}>
        <Trans
          ns="leaguesAndCups"
          i18nKey="leagueCodeDescription"
          values={{ code }}
        >
          Code to join this league: <strong>{"{{ code }}"}</strong>
        </Trans>
      </p>
      <div>
        <Button
          appearance="outlined"
          onPress={() => handleRegenerateCode(league.id)}
        >
          {t("regenerate", "Regenerate")}
        </Button>
      </div>
    </div>
  );
};

export default Code;
